function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import classNamesMaker from "classnames";
import { DATA_SPACER } from "#library/constants/enums";
import { Text, TEXT_WEIGHTS, TEXT_TYPES } from "#library/components/Text/Text";
import styles from "./signature.module.css";
export var Signature = function Signature(props) {
  var imgSrc = props.imgSrc,
    _props$imgAlt = props.imgAlt,
    imgAlt = _props$imgAlt === void 0 ? "" : _props$imgAlt,
    children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    imgProps = props.imgProps,
    _props$isRounded = props.isRounded,
    isRounded = _props$isRounded === void 0 ? false : _props$isRounded;
  var Component = "img";
  if (imgProps) {
    Component = imgProps.component;
  }
  var customClassNames = classNamesMaker(styles["jds-Signature"], _defineProperty({}, styles["jds-Signature--rounded"], isRounded), className);
  return /*#__PURE__*/React.createElement("div", {
    className: customClassNames
  }, /*#__PURE__*/React.createElement(Component, _extends({
    className: styles["jds-Signature__image"],
    alt: imgAlt,
    src: imgSrc,
    "data-spacer": DATA_SPACER.RIGHT_100
  }, imgProps)), /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    type: TEXT_TYPES.SMALL,
    weight: TEXT_WEIGHTS.NORMAL
  }, children));
};